import type { AnalyticsProvider } from '../types';

class VercelAnalyticsProvider implements AnalyticsProvider {
  public async trackPageView(path: string): Promise<void> {
    // No-op: Vercel Analytics component handles this automatically
    return Promise.resolve();
  }

  public async trackEvent(
    eventName: string,
    eventProperties?: Record<string, string | string[]>
  ): Promise<void> {
    if (typeof window === 'undefined') {
      return;
    }

    const { track } = await import('@vercel/analytics');

    // Convert properties to Vercel Analytics format (string | number | boolean | null)
    const processedProperties: Record<string, string | number | boolean | null> = {};
    if (eventProperties) {
      Object.entries(eventProperties).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          processedProperties[key] = value.join(',');
        } else {
          processedProperties[key] = value;
        }
      });
    }

    track(eventName, processedProperties);
  }

  public async identify(
    userId: string,
    traits?: Record<string, string>
  ): Promise<void> {
    // No-op: Vercel Analytics doesn't support user identification
    return Promise.resolve();
  }
}

export { VercelAnalyticsComponent } from './analytics-component';
export default new VercelAnalyticsProvider();
